import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchPagesModule } from './search-pages/search-pages.module';
import { SearchPageCounterPaginationModule } from './search-pages/components/search-page-counter-pagination/search-page-counter-pagination.module';
import { SearchPagesPageNameModule } from './search-pages/components/search-pages-page-name/search-pages-page-name.module';
import { SearchLiteraturesModule } from './search-literatures/search-literatures.module';
import { SearchLiteraturesCounterPaginationModule } from './search-literatures/components/search-page-counter-pagination/search-page-counter-pagination.module';
import { SearchLiteraturesPageNameModule } from './search-literatures/components/search-pages-page-name/search-pages-page-name.module';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SearchPagesModule,
    SearchPageCounterPaginationModule,
    SearchPagesPageNameModule,
    SearchLiteraturesModule,
    SearchLiteraturesCounterPaginationModule,
    SearchLiteraturesPageNameModule,
  ],
  exports: [],
})
export class ContentPagesModule {}
